import { Search } from 'lucide-react'
import { Input } from '../../../../components/ui/input'
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '../../../../components/ui/sheet'
import TransactionDetails from './components/TransactionDetails'
import { useTransactionTableController } from './useTransactionTableController'
import { BasicTable } from '../../../../components/BasicTable'
import { Transaction } from '../../../../../app/entities/Transaction'
import { ModalEditTransaction } from './components/TransactionDetails/components/EditTransactionModal'

interface TransactionTableProps {
  selectedItem: Transaction | null
  sheetOpen: boolean
  setSheetOpen: (open: boolean) => void
}
export const TransactionSheet = ({
  selectedItem,
  setSheetOpen,
  sheetOpen,
}: TransactionTableProps) => {
  return (
    <Sheet open={sheetOpen} onOpenChange={setSheetOpen}>
      <SheetContent className="w-[340px] overflow-y-auto rounded-2xl bg-[#F4F5F7] p-2 xs:mr-5 xs:mt-5 xs:h-[95%] xs:w-96 xs:p-5">
        <div className="min-h-[800px]">
          <SheetHeader>
            <SheetTitle className="text-xl font-semibold">
              <div className="flex items-center justify-between">
                <h2>Detalhes da transação</h2>

                {selectedItem && (
                  <ModalEditTransaction selectedTransaction={selectedItem} />
                )}
              </div>
              <div className="my-5 w-full border-b-[1px] border-gray01" />
            </SheetTitle>
          </SheetHeader>
          {selectedItem && <TransactionDetails />}
        </div>
      </SheetContent>
    </Sheet>
  )
}

export const TransactionTable = () => {
  const {
    selectedItem,
    table,
    handleRowClick,
    handleSearchInputChange,
    handleSheetState,
    sheetOpen,
    setSheetOpen,
    isLoading,
    isFetchingNextPage,
    observerRef,
    shouldShowInfiniteScroll,
  } = useTransactionTableController()

  return (
    <div className="space-y-4">
      <div className="relative flex items-center">
        <Search size={20} className="z-2 absolute left-4 top-3" />
        <Input
          className="ml-1 w-96 rounded-3xl pl-10"
          placeholder="Pesquisar"
          onChange={handleSearchInputChange}
        />
      </div>

      <TransactionSheet
        selectedItem={selectedItem}
        setSheetOpen={setSheetOpen}
        sheetOpen={sheetOpen}
      />

      <div>
        <BasicTable<Transaction>
          table={table}
          handleRowClick={handleRowClick}
          handleSheetState={handleSheetState}
          type="only header"
          isLoading={isLoading}
          isFetchingNextPage={isFetchingNextPage}
          observerRef={observerRef}
          shouldShowInfiniteScroll={shouldShowInfiniteScroll}
        />
      </div>
    </div>
  )
}
